import styled from 'styled-components';
import ChevronRightPrimary from '../../../assets/icons/chevron-right.svg';
import { B1, P3, CheckBox, P2 } from 'pfm-ui-components';
import { hexToRgba, pxToRem } from '../../../styles/utils';
import { up } from 'styled-breakpoints';
import ChevronRightBlack from '../../../assets/icons/disclaimer-right-arrow.svg';
import React from 'react';
interface AccordionProps {
  heading?: string;
  subHeading?: string;
  children?: JSX.Element;
  isOpen: boolean;
  faq?: boolean;
  setIsOpen?: Function;
  headingClassName?: string; // custom styling for heading text passed as props
  subHeadingClassName?: string; // custom styling for subheading text
  showCheckBox?: boolean;
  enableArrowForLargeScreen?: boolean;
  headerComponent?: JSX.Element;
  hideChevron?: boolean;
  error?: boolean;
  errorMessage?: string;
  isModalOpen?: boolean;
}
export default function Accordion(props: AccordionProps) {
  const {
    children,
    heading,
    isOpen,
    setIsOpen,
    headingClassName,
    subHeadingClassName,
    subHeading,
    enableArrowForLargeScreen,
    showCheckBox,
    headerComponent,
    faq,
    hideChevron,
    error,
    errorMessage,
    isModalOpen=false,
  } = props;
  return (
    <AccordianHeadingWrapper>
      {heading ? (
        showCheckBox ? (
          <CheckBoxWrapper>
            <StyledInputCheckBox
              checked={isOpen}
              label={heading}
              className="styled-checkbox"
              onChange={() => setIsOpen(!isOpen)}
              styledCheckbox={true}
            />
            <ChevronWrapper onClick={() => setIsOpen(!isOpen)}>
              <ChevronRightBlackStyled $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
            </ChevronWrapper>
          </CheckBoxWrapper>
        ) : (
          <Head faq={faq} onClick={() => setIsOpen(!isOpen)}>
            <Heading className={headingClassName}>{heading}</Heading>
            {hideChevron == null ? (
              faq ? (
                <ChevronRightPrimaryStyled $faq={faq} $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
              ) : (
                <ChevronRightBlackStyled $faq={faq} $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
              )
            ) : hideChevron == false ? (
              faq ? (
                <ChevronRightPrimaryStyled $faq={faq} $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
              ) : (
                <ChevronRightBlackStyled $faq={faq} $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
              )
            ) : (
              ''
            )}

            {/* {faq ? (
              <ChevronRightPrimaryStyled $faq={faq} $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
            ) : (
              <ChevronRightBlackStyled $faq={faq} $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
            )} */}
          </Head>
        )
      ) : (
        headerComponent && <>{headerComponent}</>
      )}

      <BodyWrapper className={isOpen ? 'show' : 'hide'} faq={faq}>
        {subHeading ? <SubHeading className={subHeadingClassName}>{subHeading}</SubHeading> : null}
        {heading ? <Body faq={faq}>{children}</Body> : <>{children}</>}
        {error && !isModalOpen ? <AccordionErrorMessage>{errorMessage && errorMessage}</AccordionErrorMessage> : ''}
      </BodyWrapper>
    </AccordianHeadingWrapper>
  );
}

const AccordianHeadingWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Head = styled.div<{ faq: boolean }>`
  ${(props) => (props.faq ? `padding : 2%` : null)};
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  ${up('md')} {
    ${(props) => (props.faq ? `padding : 2%` : null)};
    ${(props) => (props.faq ? `border-radius :0` : null)};
    cursor: default;
  }
`;

const Heading = styled(B1)<{ isOpen: boolean }>`
  font-size: ${pxToRem(14)};
  ${up('md')} {
    font-size: ${pxToRem(16)};
  }
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  margin-right: ${pxToRem(130)};
  width: 100%;
  cursor: pointer;
  ${up('md')} {
    cursor: default;
    padding: 0;
  }
  .styled-checkbox {
    border: none;
    margin: 0;
    box-shadow: none;

    .checkbox-label {
      font-size: ${pxToRem(14)};
      ${up('md')} {
        font-size: ${pxToRem(16)};
      }
    }
  }
`;

const ChevronWrapper = styled.div`
  /* position: absolute;
  right: 0; */
`;

const BodyWrapper = styled.div<{ faq: boolean }>`
&.show {
  transition: max-height 0.5s ease-in;
   ${up('md')} {
    max-height: ${pxToRem(1100)};
}
  }
  &.hide {
    max-height: 0px;
    transition: max-height 0.5s ease-out;
  }
  overflow: hidden;
  ${(props) =>
    props.faq
      ? `box-shadow: ${(props) =>
          `${pxToRem(5)} ${pxToRem(5)} ${pxToRem(12)} ${hexToRgba(props.theme.palette.black, 0.2)}`};
`
      : null}
  ${(props) =>
    props.faq
      ? ` border-bottom-right-radius: ${pxToRem(7)};
          border-bottom-left-radius: ${pxToRem(7)};`
      : null}
  ${(props) => (props.faq ? `background-color : #F6F7F8` : null)};
  ${up('md')} {
    ${(props) => (props.faq ? `border-radius :  ${pxToRem(0)}` : null)};
    ${(props) =>
      props.faq
        ? `&:last-child {
      border-bottom-right-radius: ${pxToRem(7)};
      border-bottom-left-radius: ${pxToRem(7)};
    }`
        : null};
  }
`;

const SubHeading = styled(P3)`
  padding-top: ${pxToRem(6)};
`;

const Body = styled.div<{ faq: boolean }>`
  padding-top: ${pxToRem(16)};
  ${(props) => (props.faq ? `padding :  2%` : null)};
`;

const ChevronRightBlackStyled = styled(ChevronRightBlack)<{ faq?: boolean; isOpen: boolean; enable: boolean }>`
  transition-duration: 0.8s;
  transform: ${(props) => (props.$isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
  ${up('md')} {
    display: ${(props) => (props.$faq && props.$enable ? '' : 'none')};
  }
`;

const ChevronRightPrimaryStyled = styled(ChevronRightPrimary)<{ faq: boolean; isOpen: boolean }>`
  transition-duration: 0.8s;
  transform: ${(props) => (props.$isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
  ${up('md')} {
    ${(props) => (!props.$faq ? `display : none` : null)}
  }
`;

const StyledInputCheckBox = styled(CheckBox)`
  padding-top: 0;
  align-self: flex-start;
  z-index: 1;
  margin-right: ${pxToRem(12)};
`;

const AccordionErrorMessage = styled(P2)`
  font-style: italic;
  color: red;
`;
